import {Injectable} from "@angular/core";
import {SavedSearchesParametersModel} from "../models/saved-searches-parameters.model";
import {SavedSearchesItemModel} from "../models/saved-searches-item.model";
import {SavedSearchesResultModel} from "../models/saved-searches-result.model";
import {BehaviorSubject} from "rxjs";
import {name} from "moment";

@Injectable({
    providedIn: "root"
})export class SavedSearchesService {
    private savedSearchesSubject = new BehaviorSubject<Array<SavedSearchesItemModel>>(this.getSavedSearchesFromLocalStorage());
    private readonly LOCAL_STORAGE_KEY = "savedSearches";

    public savedSearchesChanged = this.savedSearchesSubject.asObservable();

    public constructor() {
    }

    public getSearchResults(searchParams: SavedSearchesParametersModel): SavedSearchesResultModel {
        let savedSearches = this.getSavedSearchesFromLocalStorage();
        const result = new SavedSearchesResultModel();

        const startIndex = (searchParams.pageNumber - 1) * searchParams.pageSize;
        const endIndex = startIndex + searchParams.pageSize;

        savedSearches = searchParams.sortOption === "0" ? savedSearches.reverse() : savedSearches;
        result.pageSize = searchParams.pageSize;
        result.pageNumber = searchParams.pageNumber;
        result.totalItems = savedSearches.length;
        result.totalPages = Math.ceil(savedSearches.length / searchParams.pageSize);
        result.pageItems = savedSearches.slice(startIndex, endIndex);

        return result;
    }

    public updateSavedSearch(updatedSearchItem: SavedSearchesItemModel): void {
        const savedSearches = this.getSavedSearchesFromLocalStorage();
        const savedSearchToUpdate = savedSearches.find(item => item.id === updatedSearchItem.id);
        if (savedSearchToUpdate) {
            savedSearchToUpdate.name = updatedSearchItem.name;
            savedSearchToUpdate.url = updatedSearchItem.url;

            this.updateLocalStorage(savedSearches);
        }
    }

    public deleteSavedSearch(id: string): void {
        let savedSearches = this.getSavedSearchesFromLocalStorage();
        savedSearches = savedSearches.filter(item => item.id !== id);
        this.updateLocalStorage(savedSearches);
    }

    private getSavedSearchesFromLocalStorage(): Array<SavedSearchesItemModel> {
        const savedSearchesJSON = localStorage.getItem(this.LOCAL_STORAGE_KEY);
        return savedSearchesJSON ? JSON.parse(savedSearchesJSON) : [];
    }

    private updateLocalStorage(items: Array<SavedSearchesItemModel>): void {
        localStorage.setItem(this.LOCAL_STORAGE_KEY, JSON.stringify(items));
        this.savedSearchesSubject.next(items);
    }
}
